const initialState = {
  available: [
    "Tax Pro",
    "Real Estate",
    "Consultant",
    "Insurance",
    "Physician",
    "Instacart",
    "Shipt",
    "Uber",
    "Lyft",
    "Doordash",
    "Airbnb",
    "Postmates",
    "Taskrabbit",
    "Favor",
    "Wonolo",
    "Coaching",
    "Photography",
    "Creative",
    "Food Services",
    "Religious Services",
    "Trucking",
    "Tutoring"
  ],
  active: [],
  customLine: "",
  showCustomField: false,
  persona: []
}

function businessLines(state = initialState, action) {
  switch (action.type) {
    case "TOGGLE_PERSONA":
      if (state.persona.includes(action.line)) {
        const index = state.persona.indexOf(action.line)
        return {
          ...state,
          persona: [
            ...state.persona.slice(0, index),
            ...state.persona.slice(index + 1)
          ]
        }
      }
      return {
        ...state,
        persona: [...state.persona, action.line]
      }

    case "LOGIN_SUCCESS":
    case "USER_SUCCESS":
    case "UPDATE_BUSINESS_LINES_SUCCESS":
      const combined = [...action.user.income_sources, ...state.available]
      return {
        ...state,
        active: action.user.income_sources,
        available: [...new Set(combined)],
        customLine: "",
        showCustomField: false,
        persona: action.user.persona || []
      }
    case "LOGOUT_SUCCESS":
      return initialState

    case "ADD_CUSTOM_BUSINESS_LINE":
      return {
        ...state,
        showCustomField: true
      }
    case "SUBMIT_CUSTOM_LINE":
      return {
        ...state,
        available: [state.customLine, ...state.available],
        active: [state.customLine, ...state.active],
        showCustomField: false,
        customLine: ""
      }
    case "CUSTOM_LINE_CHANGE":
      return {
        ...state,
        customLine: action.value
      }
    case "TOGGLE_BUSINESS_LINE":
      if (state.active.includes(action.line)) {
        const index = state.active.indexOf(action.line)
        return {
          ...state,
          active: [
            ...state.active.slice(0, index),
            ...state.active.slice(index + 1)
          ]
        }
      }
      return {
        ...state,
        active: [...state.active, action.line]
      }
    default:
      return state
  }
}

export default businessLines



// WEBPACK FOOTER //
// ./src/account/business-lines/reducer.js